import PropTypes from "prop-types";
import React from "react";

import { Image } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { getStation } from "../Stations";

const GENERIC_IMAGE_STATION_CODE = "OA";

export const ImageByStationCode = (props) => {
  const { className, imagePath, stationCode, stationsBootstrapKey = "air/stations-data" } = props;
  const altText = i18n("ImageByStationCode__ALT_TEXT");
  const stationsOptions = { bootstrapKey: stationsBootstrapKey };
  const station = getStation(stationCode, stationsOptions);
  const showStationImage = station || stationCode === GENERIC_IMAGE_STATION_CODE;

  return showStationImage ? <Image {...getStationImageProps()} /> : null;

  function getStationImageProps() {
    return {
      alt: altText,
      "aria-hidden": "true",
      className,
      src: `${imagePath}${stationCode}.png`,
    };
  }
};

ImageByStationCode.propTypes = {
  /** Class name for the component. */
  className: PropTypes.string,

  /** Base path for the destination's image. */
  imagePath: PropTypes.string.isRequired,

  /** Airport code for locating specific airport image. */
  stationCode: PropTypes.string.isRequired,

  /** Optional bootstrap key to override stations data. */
  stationsBootstrapKey: PropTypes.string,
};
